import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {LocalStorageKey} from "@shared/config/local-storage-key";
import {LOGIN_OK} from "@shared/config/constants";

import { useReissueApi } from "@entities/auth/api/reissue-api";

interface Props {
    children: React.ReactNode;
}

const AuthGuardLayout = ({children}: Props) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const { reissueApi } = useReissueApi();
    const didRun = useRef(false);

    useEffect(() => {
        // 진입 시 재발급 검증은 정확히 1회만 한다. StrictMode(dev) 의 effect 더블-인보크에도
        // 재발급이 2회 나가지 않도록 ref 로 가드한다 — 리프레시 토큰 이중 회전/스퓨리어스 로그아웃 방지.
        // (설정에 의존하지 않고 코드로 1회를 보장 — index.tsx StrictMode 가 dev on 으로 정상화됨)
        if (didRun.current) return;
        didRun.current = true;

        const loginState = localStorage.getItem(LocalStorageKey.LOGIN_STATE);
        if (loginState !== LOGIN_OK) {
            navigate("/");
            return;
        }

        reissueApi()
            .then((result) => {
                if (result === "AUTH_FAILED") {
                    // 세션 만료 → 로그인 화면 (children 은 렌더하지 않음)
                    navigate("/");
                } else {
                    // SUCCESS 또는 일시적 ERROR → 통과.
                    // 일시적 오류로 강제 로그아웃하지 않는다(실제 401 은 axios 인터셉터가 처리).
                    setIsLoading(false);
                }
            })
            .catch(() => {
                // 예기치 못한 예외는 일시적 오류로 간주하고 통과(강제 로그아웃 금지)
                setIsLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) return null;

    return <>{children}</>;
};

export default AuthGuardLayout;
